import { render, staticRenderFns } from "./NumberOfPersonalPropertyDamagesQuestion.vue?vue&type=template&id=31a6e80c"
import script from "./NumberOfPersonalPropertyDamagesQuestion.vue?vue&type=script&lang=ts"
export * from "./NumberOfPersonalPropertyDamagesQuestion.vue?vue&type=script&lang=ts"
import style0 from "./NumberOfPersonalPropertyDamagesQuestion.vue?vue&type=style&index=0&id=31a6e80c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports